export default __webpack_public_path__ + "static/media/publicity-team-member-2.1f5dcac0.jpg";